import React from 'react'
import './Results.scss'

const Results = ({ searchValues, proposals, filterResult }) => {
  return (
    <>
      {searchValues && searchValues.length > 0 &&
          <div className='proposals_result'>
            {proposals && proposals > 0 && filterResult ?
              <>
                <p className='proposals_result_count'>
                  {`Se ${proposals > 1 ? 'ha' : 'han'} encontrado ${proposals} ${proposals > 1 ? 'resultados' : 'resultado'}`}
                </p>
                {searchValues.map((value, index) => 
                  <span key={index} className='proposals_result_chip'>{value}</span>
                )}
              </>
            :
              <div className='proposals_result_empty'>
                <p>Lo sentimos, no hemos encontrado resultados para: </p>
                <p>{searchValues.map((value, index) => 
                  <span key={index} className='proposals_result_chip'>{value}</span>
                )}</p>
                <p className='proposals_result_description' >Te sugerimos intentar nuevamente con otros parámetros de búsqueda </p>
              </div>
            } 
          </div>
        }
    </>
  )
}

export default Results
